export class OrderDashboardDto {
    subHeading: string;
    firstHeading: string;
    redColor: number;
    secondHeading: string;
    lightYellow: number;
    thirdHeading: string;
    darkYellow: number;
    fourthHeading: string;
    greenColor: number;
    fifthHeading: string;
    greyColor: number;
    confirmed?: number;
    declined?: number;
}
